import React from "react";
import LayOutContainer from "../../layout/LayOutContainer";
import { I18nextProvider } from "react-i18next";
import { LanguageProvider, LANGUAGE_STRATEGIES } from "@a365/core";
import i18n from "./../../i18n/i18n";
import FooterComponent from "../../components/footer";
import { LocationProvider } from "../../context/LocationContext";

const Footer = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <LanguageProvider i18nInstance={i18n} strategy={LANGUAGE_STRATEGIES.PAGE}>
        <LocationProvider>
          <LayOutContainer>
            <FooterComponent />
          </LayOutContainer>
        </LocationProvider>
      </LanguageProvider>
    </I18nextProvider>
  );
};

export default Footer;
